import { z } from 'zod'
import { zId } from '../common'

// GET /admin/tenants/:tenantId/seo/spend — monthly DFS budget for one tenant.

export const zSeoSpend = z
  .object({
    month: z.string(),
    tenantId: zId,
    slug: z.string(),
    spentUsd: z.number(),
    budgetUsd: z.number(),
    pct: z.number().nullable(),
    enabled: z.boolean(),
    mentionsEnabled: z.boolean(),
    baseUrl: z.string(),
    liveOptIn: z.boolean(),
  })
  .passthrough()
export type SeoSpend = z.infer<typeof zSeoSpend>
